<!--SMARTPHONE-->
<div class="navbar navbar-default navbar-fixed-top hidden-sm hidden-md hidden-lg" style="background-color: #20C4F4;" id="header">
  <div class="container-fluid" style="margin: 0;padding:0;" id="header">
    <div class="navbar-header" id="header">

      <a  class="navbar-brand navbar-brand-mobile" style="cursor: pointer;" (click)="goToHome()"><img class="phoneSizeLogo" alt="Brand" 
        src="../../assets/image/LineClear Logo - TopBar.png"  id="logo"></a>

      <button type="button" id="phoneSizeMenu" data-toggle="collapse" data-target="#navbar-ex-collapse" style="border: none; background-color: transparent;">
        <div class="container" (click)="mobileMenuBarTransform()" id="barContainer">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </button>

       

    </div>

    <div class="collapse navbar-collapse" id="navbar-ex-collapse">
      <ul class="nav navbar-nav navbar-right">
        <div class="accordion accordion-flush" id="accordionFlushExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"> 
                <span class="pad-left">TRACKING</span>
              </button>
            </h2>
            <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <a (click)="goToTracking('track')">Tracking Shipment</a>
                <a (click)="goToTracking('proof')">Proof Of Delivery Request</a>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                <span class="pad-left">SERVICES</span>
              </button>
            </h2>
            <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <a href="#">Services</a>
                <a href="#">International Shipping</a>
                <a href="#">Prepaid</a>
                <a href="#">COD</a>
                <a href="#">Line Shield</a>
                <a href="#">Shop</a>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingThree">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                <span class="pad-left">LOCATE US</span>
              </button>
            </h2>
            <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <a (click)="goToFindABranch()">Find a Branch</a>
                <a href="#">Be a Station Owner</a>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingFour">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                <span class="pad-left">JOIN US</span>
              </button>
            </h2>
            <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <a href="#">eCommerce</a>
                <a href="#">Patnerships</a>
                <a href="#">All Careers</a>
                <a href="#">Drive for Us</a>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingFive">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                <span class="pad-left">SUPPORT</span>
              </button>
            </h2>
            <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <a (click)="goToContactUs()">Contact Us</a>
                <a href="#">FAQ</a>
                <a href="#">Prohibited Items</a>
                <a href="#">Info</a>
                <a href="#">Joget</a>
              </div>
            </div>
          </div>
        </div>

      </ul>

    </div>

  </div>
</div>


<!--LAPTOP-->
<div class="navbar navbar-default navbar-fixed-top hidden-xs" style="background-color: #20C4F4;" id="header">
  <div class="container col-sm-11" >
    
      <div>

        <a style="cursor: pointer;" (click)="goToHome()" ><img height="40px" alt="Brand"
          src="../../assets/image/LineClear Logo - TopBar.png" id="logo" ></a>
      
      </div>

      <div>
        <ul style="margin:0;display:flex;align-items: center;">

          <div class="dropdown">
            <button class="dropbtn" >TRACKING</button>
            <div class="dropdown-content">
              <a (click)="goToTracking('track')">Track Shipment</a>
              <a (click)="goToTracking('proof')">Proof Of Delivery Request</a>
            </div>
          </div>

          <div class="dropdown">
            <button class="dropbtn">SERVICES</button>
            <div class="dropdown-content">
              <a href="#">Rates and Services</a>
              <a href="#">International Shipping</a>
              <a href="#">Prepaid</a>
              <a href="#">COD</a>
              <a href="#">Line Shield</a>
            </div>
          </div>

          <div class="dropdown">
            <button class="dropbtn">LOCATE US</button>
            <div class="dropdown-content">
              <a (click)="goToFindABranch()">Find a Branch</a>
              <a href="#">Be a Station Owner</a>
            </div>
          </div>

          <div class="dropdown">
            <button class="dropbtn">JOIN US</button>
            <div class="dropdown-content">
              <a href="#">eCommerce</a>
              <a href="#">Patnerships</a>
              <a href="#">All Careers</a>
              <a href="#">Drive for Us</a>
            </div>
          </div>

          <div class="dropdown">
            <button class="dropbtn">SUPPORT</button>
            <div class="dropdown-content">
              <a (click)="goToContactUs()">Contact Us</a>
              <a href="#">FAQ</a>
              <a href="#">Prohibited Items</a>
              <a href="#">Info</a>
            </div>
          </div>

          <button style="cursor: pointer;" (click)="goToPortal()" type="button" id="login"><span>LOGIN</span></button>
          
        </ul>
      </div>
    
  </div>
</div>